// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"754":"5275468c490a5ac4941e","944":"4be4aed388500f0f8c57"}[chunkId] + ".chunk.js";
};